/**
 * Badge "5% dto." junto a "Diseña Pack de 16"
 */
(function() {
  var BADGE_CLASS = 'menu-pack16-badge';
  var TARGET_RE = /dise\u00f1a pack de 16/i;

  function injectBadge() {
    document.querySelectorAll('a').forEach(function(el) {
      if (el.querySelector('.' + BADGE_CLASS)) return;
      var txt = el.textContent.trim();
      if (TARGET_RE.test(txt)) {
        el.style.whiteSpace = 'nowrap';
        var badge = document.createElement('span');
        badge.className = BADGE_CLASS;
        badge.textContent = '5% dto.';
        el.appendChild(badge);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectBadge);
  } else {
    injectBadge();
  }
  [200, 600, 1200, 2500].forEach(function(t) {
    setTimeout(injectBadge, t);
  });

  var obs = new MutationObserver(function(mutations) {
    var changed = false;
    mutations.forEach(function(m) {
      if (m.addedNodes.length || (m.type === 'attributes' && m.attributeName === 'style')) changed = true;
    });
    if (changed) injectBadge();
  });

  document.addEventListener('DOMContentLoaded', function() {
    obs.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
  });
})();
